import ProvidersList from './ProvidersList';

export default function Telemedicina() {
    return (
        <ProvidersList
            type="telemedicina"
            title="Telemedicina"
            subtitle="Benefícios de telemedicina dos assinantes."
        />
    );
}
